/* unplugin-vue-components disabled */import { render } from "./jtsbwg.vue?vue&type=template&id=ae6f9b56&scoped=true"
import script from "./jtsbwg.vue?vue&type=script&lang=js"
export * from "./jtsbwg.vue?vue&type=script&lang=js"

import "../../assets/css/t_style.css?vue&type=style&index=0&id=ae6f9b56&scoped=true&lang=css&external"
import "./jtsbwg.vue?vue&type=style&index=1&id=ae6f9b56&scoped=true&lang=scss"
import "./jtsbwg.vue?vue&type=style&index=2&id=ae6f9b56&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae6f9b56"]])

export default __exports__